import { memo } from 'react';
import { Link } from 'react-router-dom';

const TextLink = ({
	href = '', text = '', title = '', external, color = 'text-oly-blue-dark',
}) => (
	<>
		{external && (
			<a href={href} className={`text-[0.875rem] transition duration-150 ease-in-out ${color} focus:outline-none focus-visible:underline can-hover:hover:underline`} rel="noreferrer" target="_blank">
				{text}
			</a>
		)}
		{!external && (
			<Link to={href} title={title} className={`text-[0.875rem] transition duration-150 ease-in-out ${color} focus:outline-none focus-visible:underline can-hover:hover:underline`}>
				{text}
			</Link>
		)}
	</>
);

export default memo(TextLink);
